import { styled } from "@mui/system";
import { Button } from "@mui/material";

const PrimaryButton = styled(Button)`
  && {
    background: #1E3F66;
    color: #ffffff;
    border-radius: 4px;
    box-shadow: none;
    text-transform: capitalize;
    min-width: 6rem;
    width: fit-content;
    padding: 0.3rem 0.6rem;
    &:hover {
      background-color:rgb(34, 73, 121);
    }

    &:disabled {
      background-color: #e0e0e0;
      color: #a0a0a0;
    }
  }
`;

export default PrimaryButton;
